const options = {
  rootMargin: '25vh',
}
const hidden = document.querySelectorAll('.view');

const observer = new IntersectionObserver(fadeIn);
hidden.forEach(hidden => {
  observer.observe(hidden);
});

function fadeIn(entries){
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.classList.add('inView');
      //entry.target.classList.remove('view');
    };
  });
};
